import {
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material'
import { DarkMode, LightMode } from '@mui/icons-material'
import PageSection from '../../Constants&Theme/PageSection'
import { stuartColours } from '../../Constants&Theme/ColourLookup'
import { darkMode } from '../../Functions/GetColourPalette'
import { useSetUserPref } from '../../APIs/Hooks/UserHooks'
import { useUserContext } from '../../Contexts/UserConfig'
import { stackGap } from '../../Constants&Theme/Spacing'

function ColourSettings() {
  const { loginConfig } = useUserContext()
  const { mutate: setUserPref } = useSetUserPref()

  const dark = darkMode(loginConfig)
  const colourOptions = stuartColours.map((c) => (
    <MenuItem
      value={c}
      key={c}
    >
      {c}
    </MenuItem>
  ))

  return (
    <PageSection title={'Colour Settings'}>
      <Stack
        direction={'row'}
        width={1}
        gap={stackGap.row}
      >
        <FormControl fullWidth>
          <InputLabel>Colour</InputLabel>
          <Select
            aria-label={'Theme Colour'}
            label="Colour"
            value={loginConfig?.UserPrefs?.WindowColour ?? ''}
            onChange={(e) =>
              setUserPref({ name: 'WindowColour', value: e.target.value })
            }
          >
            {colourOptions}
          </Select>
        </FormControl>
        <ButtonGroup
          color="primary"
          fullWidth
        >
          <Button
            aria-label={'Light Mode'}
            disabled={!dark}
            onClick={() => setUserPref({ name: 'DarkMode', value: false })}
            sx={{ height: '3.5rem', alignItems: 'bottom' }}
          >
            <LightMode />
          </Button>
          <Button
            aria-label={'Dark Mode'}
            disabled={dark}
            onClick={() => setUserPref({ name: 'DarkMode', value: true })}
            sx={{ height: '3.5rem' }}
          >
            <DarkMode />
          </Button>
        </ButtonGroup>
      </Stack>
    </PageSection>
  )
}

export default ColourSettings
